// Generated by ReScript, PLEASE EDIT WITH CARE


let values = [
  "FR",
  "FR_20R",
  "FR_974",
  "FR_973",
  "BE",
  "LU"
];

function toIso2String(value) {
  switch (value) {
    case "FR" :
      return "FR";
    case "FR_20R" :
      return "FR-20R";
    case "FR_974" :
      return "FR-974";
    case "FR_973" :
      return "FR-973";
    case "BE" :
      return "BE";
    case "LU" :
      return "LU";
  }
}

function toIsoString(value) {
  switch (value) {
    case "FR" :
    case "FR_20R" :
    case "FR_974" :
    case "FR_973" :
      return "FR";
    case "BE" :
      return "BE";
    case "LU" :
      return "LU";
  }
}

function toLongCountryString(value) {
  switch (value) {
    case "FR" :
      return "France - Mainland";
    case "FR_20R" :
      return "France - Corsica";
    case "FR_974" :
      return "France - Reunion Island";
    case "FR_973" :
      return "France - French Guiana";
    case "BE" :
      return "Belgium";
    case "LU" :
      return "Luxembourg";
  }
}

function toMediumCountryString(value) {
  switch (value) {
    case "FR" :
    case "FR_20R" :
    case "FR_974" :
    case "FR_973" :
      return "France";
    case "BE" :
      return "Belgium";
    case "LU" :
      return "Luxembourg";
  }
}

function fromString(value) {
  switch (value) {
    case "BE" :
      return {
        TAG: "Ok",
        _0: "BE"
      };
    case "FR" :
      return {
        TAG: "Ok",
        _0: "FR"
      };
    case "FR_20R" :
      return {
        TAG: "Ok",
        _0: "FR_20R"
      };
    case "FR_973" :
      return {
        TAG: "Ok",
        _0: "FR_973"
      };
    case "FR_974" :
      return {
        TAG: "Ok",
        _0: "FR_974"
      };
    case "LU" :
      return {
        TAG: "Ok",
        _0: "LU"
      };
    default:
      return {
        TAG: "Error",
        _0: "Unknown country code"
      };
  }
}

function parseIso3166Alpha2(string) {
  let clean = string.trim().toLowerCase();
  switch (clean) {
    case "be" :
    case "bel" :
    case "belge" :
    case "belgique" :
    case "belgium" :
      return "BE";
    case "fr" :
    case "fra" :
    case "france" :
    case "french" :
      return "FR";
    case "lu" :
    case "lux" :
    case "luxembourg" :
      return "LU";
    default:
      let match = fromString(string);
      if (match.TAG !== "Ok") {
        return {
          TAG: "InvalidCountryCode",
          _0: string
        };
      }
      switch (match._0) {
        case "BE" :
          return "BE";
        case "LU" :
          return "LU";
        default:
          return "FR";
      }
  }
}

export {
  values,
  toIso2String,
  toIsoString,
  toLongCountryString,
  toMediumCountryString,
  fromString,
  parseIso3166Alpha2,
}
/* No side effect */
